import emitter from '@/services/infrastructure/emitter'
import {NO_ORG_SELECTED, ORG_SELECTED} from '@/types/events'
import {myOrgs, selectedOrg, switchOrg} from '@/tenants/org.service'
const orgPattern = /\/organization\/([^/?#]+)/

const cleanUpUrl = () => {
    const newUrl = window.location.href.replace(orgPattern, '/')
    setPath(newUrl)
}

const setPath = (path: string) => {
    const existingHash = window.location.hash
    window.history.replaceState(window.history.state, '', path)
    if (existingHash) {
        window.location.hash = existingHash
    }
}
const applyTenantFromUrl = () => {
    const url = window.location.href

    const match = url.match(orgPattern)
    if (!match || match.length < 2) {
        return
    }

    const tenantId = match[1]
    const org = myOrgs.value.find(o => o.organizationId === tenantId)
    if (!org) {
        cleanUpUrl()
        return
    }

    if (org === selectedOrg.value) {
        cleanUpUrl()
        return
    }
    cleanUpUrl()
    switchOrg(org)
}

emitter.on(NO_ORG_SELECTED, applyTenantFromUrl)
emitter.on(ORG_SELECTED, applyTenantFromUrl)